import {sessionHandoffSchema} from "@finance/shared";
import {assistantHandoffParam} from "@finance/shared/embed";

let pending: string | null = null;

/**
 * Takes the one-time code a plugin's "Open Sprout" link carries in its
 * fragment and removes it from the address bar before monitoring,
 * attribution, or analytics read the URL. The session check redeems it.
 * Links open top-level; a framed page could be overlaid to capture the
 * confirming tap, so it keeps no code.
 */
export function captureLinkHandoff(): void {
  const fragment = new URLSearchParams(window.location.hash.slice(1));
  const code = fragment.get(assistantHandoffParam);
  if (code === null) return;
  fragment.delete(assistantHandoffParam);
  window.history.replaceState(window.history.state, "", `${window.location.pathname}${window.location.search}${fragment.size > 0 ? `#${fragment}` : ""}`);
  pending = window.top === window.self && sessionHandoffSchema.safeParse({code}).success ? code : null;
}

/** The captured code, once: a spent or refused code is never sent again. */
export function takeLinkHandoff(): string | null {
  const code = pending;
  pending = null;
  return code;
}
